import styled from 'styled-components';

import { TChipContainer } from '@/shared/components/ui/chip/chip.types';

export const ChipContainer = styled.span<TChipContainer>`
  && {
    width: fit-content;
    display: inline-flex;
    align-items: center;
    align-self: inherit;
    gap: 0.25rem;
    cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
    padding: 0 0.5rem;
    border: 1px solid
      ${({ theme, $status }) => theme.palette.status[$status].stroke};
    border-radius: ${({ theme, $variant }) =>
      $variant === 'status' ? theme.shape.tagRadius : theme.shape.chipRadius};
    background-color: ${({ theme, $status, $variant }) =>
      $variant === 'outline'
        ? 'transparent'
        : theme.palette.status[$status].background};
    color: ${({ theme, $status }) => theme.palette.status[$status].text};
    text-wrap: nowrap;

    ${({ $variant }) => $variant === 'status' && `height: 1.625rem;`}

    svg {
      color: ${({ theme, $status }) => theme.palette.status[$status].text};

      &:not(.chip-dot) {
        height: 1.25rem;
        width: 1.25rem;
        margin: 0.25rem 0;
      }
    }
  }
`;
